"use strict";

var React = require("react"),
    PropTypes = require("prop-types"),
    CloseIcon = require("../icons/CloseIcon.js"),
    classnames = require("classnames"),
    BaseModal = function BaseModal(e) {
  var s = e.classes,
      l = e.className,
      a = e.style,
      o = e.isHidden,
      r = e.isClosable,
      c = e.onClose,
      n = e.children;
  return o ? null : React.createElement(React.Fragment, null, React.createElement("div", {
    className: classnames("blx-modal-overlay", s.overlay),
    onClick: c
  }), React.createElement("div", {
    className: classnames("blx-modal", s.root, l),
    style: a
  }, r && React.createElement("button", {
    className: classnames("blx-modal-close", s.close),
    "aria-label": "close",
    onClick: c
  }, React.createElement(CloseIcon, null)), n));
};

BaseModal.propTypes = {
  classes: PropTypes.shape({
    root: PropTypes.string,
    close: PropTypes.string,
    overlay: PropTypes.string
  }),
  className: PropTypes.string,
  style: PropTypes.object,
  isHidden: PropTypes.bool,
  isClosable: PropTypes.bool,
  onClose: PropTypes.func,
  children: PropTypes.node
}, BaseModal.defaultProps = {
  classes: {},
  className: "",
  style: null,
  isHidden: !0,
  isClosable: !0,
  onClose: function onClose() {},
  children: null
}, module.exports = BaseModal;